module.exports = __webpack_public_path__ + "static/img/branded_location_icon.bac29b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enterprise/branded_location_icon.png
// module id = enMn
// module chunks = 0